// csvExport.js
function get(obj, path) {
  if (!path) return undefined;
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
}

function defaultSerialize(value) {
  if (value == null) return "";
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

function escapeCsvCell(v, delimiter) {
  const needsQuotes = v.includes(delimiter) || v.includes('"') || v.includes("\n") || v.includes("\r") || v.includes(";");
  const escaped = v.replace(/"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
}

function inferColumnsFromRow(row) {
  if (!row || typeof row !== "object") return [];
  return Object.keys(row).map((k) => ({ header: k, key: k }));
}

export function buildCsv(rows, opt = {}) {
  const {
    columns = rows?.length ? inferColumnsFromRow(rows[0]) : [],
    delimiter = ";",
    eol = "\r\n",
    excelSepHint = true,
    nullAsEmpty = true,
    defaultFormatter,
  } = opt;

  const header = columns.map((c) => escapeCsvCell(c.header, delimiter)).join(delimiter);

  const lines = rows.map((r0) => {
    const r = opt.transformRow ? opt.transformRow(r0) : r0;
    return columns
      .map((c) => {
        const raw = typeof c.accessor === "function" ? c.accessor(r) : c.key ? get(r, c.key) : undefined;
        const val = raw == null && nullAsEmpty ? "" : raw;
        const formatted = c.format ? c.format(val, r) : (defaultFormatter ? defaultFormatter(val, r) : defaultSerialize(val));
        return escapeCsvCell(formatted, delimiter);
      })
      .join(delimiter);
  });

  const parts = [];
  if (excelSepHint) parts.push(`sep=${delimiter}`);
  parts.push(header, ...lines);
  return parts.join(eol);
}

export function downloadCsv(csv, baseName = "export", opt = {}) {
  const includeBom = opt.includeBom ?? true;
  const dateSuffix = opt.dateSuffix ?? true;

  const blob = new Blob([includeBom ? "\uFEFF" + csv : csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const date = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `${baseName}${dateSuffix ? "_" + date : ""}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default function exportToCsv(rows, options = {}) {
  const csv = buildCsv(rows, options);
  downloadCsv(csv, options.filename ?? "export", { includeBom: options.includeBom, dateSuffix: options.dateSuffix });
}
